export default "__VITE_ASSET__q_pnPQb9__"